export const appActionArgumentRequired = {
  key: 'appActionArgumentRequired',
  type: 'app',
  label: 'Required Argument',
  description: 'Suggests if an argument should be marked as required based on API documentation',
  path: 'actions[id:{{actionId}}].arguments[id:{{argumentId}}].required',
  shouldRun: ({ changes }) => {
    return !changes?.some((change) => change?.path?.includes('arguments') && change?.path?.endsWith('required'));
  },
  context: ['actionDocs', 'argumentId'],
  mapContext: ({ app, action, actionDocs, argumentId }) => {
    return {
      name: action?.name,
      model: action?.model,
      operation: action?.operation || 'none',
      description: action?.description,
      slug: action?.slug,
      appName: app?.name,
      argument: action?.arguments?.find((arg) => arg?.id === argumentId),
      actionDocs
    };
  },
  prompt: 'appActionArgumentRequired'
};
